import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    redirect : '/diablo2/runewordSearch'
  },
  {
    path: '/diablo2',
    name: "diablo2",
    redirect:'/diablo2/runewordSearch',
    component: () => import('../views/diablo2/Index.vue'),
    children: [
      {
        path: 'runeList',
        component: () => import('../views/diablo2/RuneList.vue')
      },
      {
        path: 'runewordList',
        component: () => import('../views/diablo2/RunewordList.vue')
      },
      {
        path: 'runewordSearch',
        component: () => import('../views/diablo2/RunewordSearch.vue')
      },
      {
        path: 'itemCategoryList',
        component: () => import('../views/diablo2/ItemCategoryList.vue')
      },
      {
        path: 'releaseNote',
        component: () => import('../views/diablo2/ReleaseNote.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
